import { useOutletContext, useParams } from 'react-router-dom'
import { Download } from 'lucide-react'
import NoContentBanner from '../../common/Banner/No-Content-Banner'

const UserLiveClassPageV2 = () => {
  const { moduleIndex, contentIndex } = useParams()
  const { modules } = useOutletContext()
  const foundClass = modules[moduleIndex]?.contents[contentIndex]
  const moduleName = modules[moduleIndex]?.moduleName

  return (
    <main className="w-full space-y-6">
      {/* Breadcrumbs */}
      <div className="breadcrumbs text-sm">
        <ul className="flex flex-wrap items-center gap-1">
          <li>
            <a className="break-words">{moduleName}</a>
          </li>
        </ul>
      </div>

      <>
        {!foundClass ? (
          <NoContentBanner text="Found No Class Here. Explore Sidebar to unlock modules." />
        ) : (
          <div className="space-y-6">
            <div className="relative">
              <iframe
                src={foundClass?.videoUrl}
                loading="lazy"
                className="w-full rounded-lg aspect-video"
                allowFullScreen
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              />
            </div>
            {/* Title */}
            <h4 className="text-xl font-medium">{foundClass?.lectureName}</h4>
            {/* Contents */}
            {foundClass?.lectureContent && (
              <div className="w-full flex justify-between items-center space-x-4 bg-white border-blue border font-bold py-2 px-4 rounded">
                <p>Download Resource</p>
                <a href={foundClass?.lectureContent} download className="">
                  <Download className="stroke-primary" />
                </a>
              </div>
            )}
          </div>
        )}
      </>
    </main>
  )
}

export default UserLiveClassPageV2
